module.exports = __webpack_public_path__ + "static/media/trawill.3bc60023.gif";